import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import ReactMarkdown from 'react-markdown';

import Image from '../partials/Image';
import Link from '../partials/Link';

import BlockComponent from './BlockComponent';
import blockDefinition from './definitions/slides.json';

const propTypes = {
    slides: PropTypes.array,
    horizontal: PropTypes.bool,
    ratio: PropTypes.number,
};

const defaultProps = {
    slides: [
        {
            id: 33,
            media: {
                url: '/img/placeholders/quote.jpg',
            },
            title: 'About stuff',
            icon: 'video',
            route: '/the-film/news',
            quote: 'This is a quote',
        },
        {
            id: 22,
            media: {
                url: '/img/placeholders/bigquote.jpg',
            },
            route: '/first-hand-experiences/quotes',
            quote: 'This is a quote again',
        },
    ],
    ratio: undefined,
    horizontal: false,
};

class SlidesBlock extends BlockComponent {
    constructor(props) {
        super(props);
        this.renderSlide = this.renderSlide.bind(this);
    }

    // eslint-disable-next-line class-methods-use-this
    renderSlide(item, index) {
        const { ratio } = this.props;

        const hasLink = typeof item.link !== 'undefined' && item.link !== null;
        const icon = item.icon || (hasLink ? item.link.icon : null) || null;
        const color = item.color || (hasLink ? item.link.color : null) || null;
        const hasIcon = icon !== null;
        const labelClassName = classNames({
            'slide-label': true,
            'with-icon': hasIcon,
            [`color-${color}`]: color !== null,
        });

        const iconClassName = hasIcon ? classNames({
            icon: true,
            [icon]: true,
            colored: true,
        }) : null;

        const title = !isEmpty(item.title) ? (
            <strong className="text small font-inline"><span className={iconClassName} />{item.title}</strong>
        ) : null;

        const description = !isEmpty(item.description) ? (
            <span className="text">
                <ReactMarkdown source={item.description} />
            </span>
        ) : null;

        const quote = !isEmpty(item.quote) ? (
            <span className="quote"><ReactMarkdown source={item.description} /></span>
        ) : null;

        const content = (
            <span className="slide-content">
                { !isEmpty(item.picture) ? (
                    <Image
                        media={item.picture}
                        ratio={ratio}
                        background
                    />
                ) : null }
                { title !== null || description !== null || quote !== null ? (
                    <span className={labelClassName}>
                        { title === null ? (
                            <span className={iconClassName} />
                        ) : null }
                        { title }
                        { description }
                        { quote }
                    </span>
                ) : null }
            </span>
        );

        return (
            <div key={`slide-${index}`} className="slide">
                { !isEmpty(item.link) ? (
                    <Link to={item.link.pathname} className="page-link">{ content }</Link>
                ) : content }
            </div>
        );
    }

    render() {
        const { slides, horizontal } = this.props;
        const className = classNames({
            'block-slides': true,
            horizontal,
        });
        return (
            <div className={className}>
                <div className="inner">
                    { (slides || []).map((slide, index) => (
                        horizontal ? (
                            <div className="col" key={`slide-col-${slide.id || index}`}>
                                { this.renderSlide(slide, index) }
                            </div>
                        ) : this.renderSlide(slide, index)
                    )) }
                </div>
            </div>
        );
    }
}

SlidesBlock.propTypes = propTypes;
SlidesBlock.defaultProps = defaultProps;
SlidesBlock.blockDefinition = blockDefinition;

export default SlidesBlock;



// WEBPACK FOOTER //
// ./components/blocks/Slides.jsx